export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./home.vue?vue&type=template&id=39f87be5&"


//////////////////
// WEBPACK FOOTER
// ./src/views/home/home.vue?vue&type=template&id=39f87be5&
// module id = null
// module chunks = 